import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faUpload } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const AcaoCard = ({ acao }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Nome:
            </div>
            <div className={styles.info}>
                {acao.nome}
            </div>
            <div className={styles.title}>
                Tipo de ação:
            </div>
            <div className={styles.info}>
                {acao.tipoAcao}
            </div>
            <div className={styles.title}>
                Início
            </div>
            <div className={styles.info}>
                {new moment(acao.dataInicio).format('DD/MM/YYYY') }
            </div>
            <div className={styles.title}>
                Término:
            </div>
            <div className={styles.info}>
                {new moment(acao.dataFinal).format('DD/MM/YYYY')}
            </div>
            <div className={styles.actionWrapper}>

                { acao.status === 0 && (<div className={styles.encerrado}>RASCUNHO</div>) }
                { acao.status === 1 && (<div className={styles.andamento}>EM ANDAMENTO</div>) }
                {  acao.status === 2 && (<div className={styles.encerrado}>ENCERRADO</div>) }
                
                <button className={styles.editar} onClick={() => {history.push(`/campanhas/adicionar?campanha=${acao.id}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faUpload} className={styles.icon}/>
                </button>
            </div>
        </div>
    )
}

export default AcaoCard